import { render, staticRenderFns } from "./physique.vue?vue&type=template&id=5ab09e6a&scoped=true"
import script from "./physique.vue?vue&type=script&lang=js"
export * from "./physique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab09e6a",
  null
  
)

export default component.exports